export default Object.freeze({
  PENDING: 'pending',
  COMPLETE: 'complete',
})
